import { render, staticRenderFns } from "./NotesCreated.vue?vue&type=template&id=5b3cf7a8&scoped=true&"
import script from "./NotesCreated.vue?vue&type=script&lang=js&"
export * from "./NotesCreated.vue?vue&type=script&lang=js&"
import style0 from "./NotesCreated.vue?vue&type=style&index=0&id=5b3cf7a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3cf7a8",
  null
  
)

export default component.exports